// Vendors
import { isMobileDevice, isTabletDevice } from '@openbank/cf-ui-framework';
import {
  TrackingErrorEventReturnType,
  TrackingEventsEnum,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@openbank/cf-ui-static-data';
// Constants
import constants from './constants/app.tracking.utils.constants';
// Types
import { LinkTrackingPropsType } from './types/link-tracking.configuration.type';
import {
  ViewTrackingPropsErrorType,
  ViewTrackingPropsType,
} from './types/view-tracking.configuration.type';

const getWebDeviceVersion = (): string => {
  switch (true) {
    case isMobileDevice():
      return constants.DEVICE_TYPES.MOBILE;
    case isTabletDevice():
      return constants.DEVICE_TYPES.TABLET;
    default:
      return constants.DEVICE_TYPES.DESKTOP;
  }
};

export default getWebDeviceVersion;

export const getViewTypeTrackingConfiguration = (
  payload: ViewTrackingPropsType
): TrackingViewEventReturnType => ({
  payload,
  type: TrackingEventsEnum.VIEW,
});

export const getViewErrorTypeTrackingConfiguration = (
  payload: ViewTrackingPropsErrorType
): TrackingViewEventReturnType => ({
  payload,
  type: TrackingEventsEnum.VIEW,
});

export const getLinkTypeTrackingConfiguration = (
  payload: LinkTrackingPropsType
): TrackingLinkEventReturnType => {
  return {
    payload,
    type: TrackingEventsEnum.LINK,
  };
};

export const getLinkErrorTrackingConfiguration = (
  payload: LinkTrackingPropsType
): TrackingErrorEventReturnType => ({
  payload,
  type: TrackingEventsEnum.LINK,
});
